import React from "react";
import { toUrl } from "@/lib/redcarpet";

// Accessible player: YouTube/Vimeo iframe or native MP4 with poster + captions. Never autoplays with sound.
export default function RedCarpetVideo({ video, title, testid = "rc-video" }) {
  if (!video?.url) return null;
  if (video.embed_url) {
    return (
      <div className="relative w-full aspect-video rounded-3xl overflow-hidden bg-black soft-shadow" data-testid={testid}>
        <iframe src={video.embed_url} title={title} className="absolute inset-0 w-full h-full" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen loading="lazy" />
      </div>
    );
  }
  return (
    <video controls playsInline preload="metadata" poster={toUrl(video.poster) || undefined} className="w-full aspect-video rounded-3xl bg-black soft-shadow" data-testid={testid}>
      <source src={toUrl(video.url)} type="video/mp4" />
      {video.captions_url && <track kind="captions" src={toUrl(video.captions_url)} srcLang="en" label="English" default />}
      Your browser can't play this video — <a href={toUrl(video.url)}>download it instead</a>.
    </video>
  );
}
